import { Loader } from "../net/Loader";
import { PAL } from "../platform/PlatformAdapters";
class WebAudioLoader {
    load(task) {
        return task.loader.fetch(task.url, "arraybuffer", task.progress.createCallback(), task.options).then(data => {
            if (!data)
                return null;
            let size = data.byteLength;
            return PAL.media.decodeAudioData(data).then(buffer => {
                if (buffer)
                    buffer.__byteLength = size;
                return buffer;
            });
        });
    }
}
Loader.registerLoader(["mp3", "wav", "ogg"], WebAudioLoader, Loader.SOUND);
